<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <!-- <v-card v-if="ay_list != null">
            <v-card-text> -->
    <v-card class="box" v-if="ay_list != null">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Room Offering</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <!-- <v-row justify="center"> -->
      <!-- <v-col sm="6" style="text-align: left;">
                        <h2>Room Offering</h2>
                    </v-col> -->
      <!-- <v-col sm="6" style="text-align: right;"> -->
      <!-- <span style="opacity: 0.5;">Copy room offering </span>
                        <v-btn text title="Copy from previous academic year" @click="copyRoomOffering">
                            <v-icon color="green">mdi-content-copy</v-icon>
                        </v-btn> -->
      <!-- </v-col> -->
      <!-- </v-row> -->
      <v-row justify="center" dense class="mt-3">
        <v-col sm="3" class="p-0 m-0">
          <v-combobox dense rounded required v-model="curr_ay" :items="ay_list" item-text="Academic Year"
            label="Academic Year" outlined />
        </v-col>
        <v-col sm="3" class="p-0 m-0">
          <span style="opacity: 0.5">Copy room offering </span>
          <v-btn text title="Copy from previous academic year" @click="copyRoomOffering">
            <v-icon color="green">mdi-content-copy</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <template v-if="rooms_list.length != 0">
        <v-row class="toolbar" dense justify="center">
          <h3>Please select rooms</h3>
        </v-row>
        <v-row justify="space-around">
          <v-switch color="#0f2027" v-model="rooms" v-for="room in rooms_list" :key="room" :label="room"
            :value="room"></v-switch>
        </v-row>
        <hr style="background-color: #e0e0e0; height: 1px; opcacity: 0.4" />
        <v-row justify="center">
          <v-col sm="3">
            <v-combobox dense rounded required v-model="room_type" :items="room_type_list" item-text="Offer Room As"
              label="Offer Room As" outlined />
          </v-col>
          <v-col sm="3">
            <v-btn @click="addRoomOffering" class="button pt-0 mt-0" :loading="offer_btn_load">Offer</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-alert icon="mdi-google-classroom" prominent text type="warning">
          All Rooms already offered
        </v-alert>
      </template>
      <!-- </v-card-text> -->
    </v-card>
    <v-card v-if="offered_rooms_list != null" class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Offered Rooms</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar flat dense>
        <!-- Offered Rooms -->
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-toolbar>
      <v-data-table :headers="headers" :items="offered_rooms_list" dense class="elevation-1 mytable" :search="search">
        <template v-slot:item.action="{ item }">
          <v-btn small rounded outlined color="#0f2027" icon class="mr-2">
            <v-icon color="#0f2027" small @click="editItem(item)">edit</v-icon>
          </v-btn>
          <v-btn small rounded outlined color="error" icon>
            <v-icon color="error" small :loading="delete_offer_btn_load" @click="deleteItem(item)">delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <!-- Edit Room Ofering dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Edit Offered Rooms</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- <v-card-text> -->
        <v-container>
          <v-row dense justify="center">
            <v-col cols="12" sm="4" md="4">
              <v-combobox dense outlined rounded required v-model="editedItem.room_no" :items="rooms_list"
                item-text="Room Number" label="Room Number" />
              <!-- <v-text-field v-model="editedItem.room_no" label="Room Number"></v-text-field> -->
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-combobox dense outlined rounded required v-model="editedItem.room_type" :items="room_type_list"
                item-text="Offer Room As" label="Offer Room As" />
              <!-- <v-text-field v-model="editedItem.room_type" label="Room Type"></v-text-field> -->
            </v-col>
          </v-row>
        </v-container>
        <!-- </v-card-text> -->
        <!-- <v-card-actions>
                    <v-spacer></v-spacer> -->
        <v-row dense justify="center">
          <v-btn class="button" @click="close">Cancel</v-btn>
          <v-btn class="button" :loading="edit_offer_btn_load" @click="save">Save</v-btn>
        </v-row>
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
    <!-- Copy Room Ofering dialog -->
    <v-dialog v-model="copy_dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-combobox dense required v-model="from_ay" :items="ay_list" item-text="From Academic Year"
                  label="From Academic Year" outlined />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-combobox dense required v-model="to_ay" :items="ay_list" item-text="To Academic Year"
                  label="To Academic Year" outlined />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" :loading="copy_offer_btn_load" text @click="saveCopyRoomOffering">Copy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {

  components: {
    Breadcrumbs,
  },
  data: () => ({
    curr_ay: null,
    ay_list: null,
    // extraBreadcrumbItems: [
  

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    rooms_list: null,
    offered_rooms_list: null,
    room_type_list: null,
    room_type: null,
    rooms: [],
    headers: [
      { text: "Sr. No", value: "srno" },
      { text: "AY", value: "ay" },
      { text: "Room Number", value: "room_no" },
      { text: "Room Name", value: "room_name" },
      { text: "Room Type", value: "room_type" },
      { text: "Actions", value: "action", sortable: false },
    ],
    dialog: false,
    copy_dialog: false,
    editedItem: {
      srno: null,
      room_no: null,
      room_type: null,
      room_name: null,
      ay: null,
    },
    editedIndex: -1,
    search: "",
    from_ay: null,
    to_ay: null,

    offer_btn_load: false,
    edit_offer_btn_load: false,
    delete_offer_btn_load: false,
    copy_offer_btn_load: false,
  }),
  watch: {
    curr_ay() {
      (this.rooms = []), this.roomOffering();
    },
    dialog(val) {
      val || this.close();
    },
    copy_dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.roomOffering();
  },
  methods: {
    copyRoomOffering() {
      var index = this.ay_list.indexOf(this.curr_ay) - 1;
      if (index < 0) index = 0;
      this.from_ay = this.ay_list[index];
      this.to_ay = this.curr_ay;
      this.copy_dialog = true;
    },
    saveCopyRoomOffering() {
      if (this.from_ay == null || this.to_ay == null) {
        alert("Please select Academic year!!!");
        return;
      }
      if (this.from_ay == this.to_ay) {
        alert("From and To Academic year cannot be same!!!");
        return;
      }
      this.copy_offer_btn_load = true;
      const formData = {
        from_ay: this.from_ay,
        to_ay: this.to_ay,
      };
      axios
        .post("/timeTable/copyRoomOffering", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.rooms_list = res.data.rooms_list;
            this.offered_rooms_list = res.data.offered_rooms_list;
            this.curr_ay = res.data.curr_ay;
          } else {
            alert(res.data.status_reason);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.copy_offer_btn_load = false;
          this.close();
        });
    },
    editItem(item) {
      this.editedIndex = this.offered_rooms_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.delete_offer_btn_load = true;
      axios
        .post("/timeTable/deleteRoomOffering", item)
        .then((res) => {
          if (res.data.status == "YES") {
            this.rooms_list = res.data.rooms_list;
            this.offered_rooms_list = res.data.offered_rooms_list;
          } else {
            alert(res.data.status_reason);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_offer_btn_load = false;
          this.close();
        });
    },
    close() {
      this.dialog = false;
      this.copy_dialog = false;
    },
    save() {
      this.edit_offer_btn_load = true;
      axios
        .post("/timeTable/editRoomOffering", this.editedItem)
        .then((res) => {
          if (res.data.status == "YES") {
            this.rooms_list = res.data.rooms_list;
            this.offered_rooms_list = res.data.offered_rooms_list;
          } else {
            alert(res.data.status_reason);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.edit_offer_btn_load = false;
          this.close();
        });
    },
    addRoomOffering() {
      if (
        this.curr_ay == null ||
        this.room_type == null ||
        this.rooms.length == 0
      ) {
        alert("Please select AY, Room-Type and Rooms");
        return;
      }
      this.offer_btn_load = true;

      const formData = {
        curr_ay: this.curr_ay,
        room_type: this.room_type,
        rooms: this.rooms,
      };
      axios
        .post("/timeTable/addRoomOffering", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.rooms_list = res.data.rooms_list;
            this.offered_rooms_list = res.data.offered_rooms_list;
          } else {
            //error
            alert(res.data.status_reason);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.rooms = [];
          this.offer_btn_load = false;
        });
    },
    roomOffering() {
      const formData = {
        curr_ay: this.curr_ay,
      };
      axios
        .post("/timeTable/roomOffering", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.curr_ay = res.data.curr_ay;
            this.ay_list = res.data.ay_list;
            this.rooms_list = res.data.rooms_list;
            this.offered_rooms_list = res.data.offered_rooms_list;
            this.room_type_list = res.data.room_type_list;
            this.room_type = this.room_type_list[0];
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
  },
};
</script>
<style scoped>
</style>


